import { Page } from '@/typings/page';
import useCurrentPage from '@/hooks/useCurrentPage';
import { RefitLanding } from '@/modules/RefitLanding/types';

export function useRefitData(): Page<RefitLanding> {
  return useCurrentPage<Page<RefitLanding>>();
}
